import clsx from 'clsx'
import React from 'react'

type Props = {
  className?: string
  children?: any
  style?: any
}

const TableWrapper: React.FC<Props> = ({className, children, style}) => {
  return (
    <div className={clsx('card', className)} style={style}>
      {children}
    </div>
  )
}

export {TableWrapper}
